import React from 'react';
import Overview from '../cards/Overview';

export default function Dashboard() {
    return (
            <Overview />
    );
}
